<template>
    <b-card>
        <b-row>
            <b-col
                    class="table-size"
            >
                <div class="custom-search">
                    <b-row>
                        <div class="filter-row" style="justify-content: flex-start">
                            <b-button
                                class="ml-1"
                                variant="outline-primary"
                                size="sm"
                                :to="{ name: 'addproductcolor', query:{ productid: $route.params.id }}"
                            >
                                جدید
                            </b-button>
                        </div>
                    </b-row>
                </div>
                <b-table
                        bordered
                        hover
                        striped
                        :items="items"
                        :fields="fields"
                        class="mt-1 mb-2 position-relative"
                        responsive
                        :busy="loading"
                >
                    <template #cell(Id)="data">
                        <b-link
                                :to="{ name: 'updateproductcolor', params: { id: data.value }, query:{ productid: $route.params.id }}"
                                class="font-weight-bold"
                        >
                            #{{ data.value }}
                        </b-link>
                    </template>

<!--                    <template #cell(Status)="data">-->
<!--                        <b-badge-->
<!--                            :variant="enums('ProductStatus', 'value', data.value, 'badge')"-->
<!--                        >-->
<!--                            {{ enums('ProductStatus', 'value', data.value, 'text') }}-->
<!--                        </b-badge>-->
<!--                    </template>-->

                    <template #cell(Price)="data">
                        {{ data.value | price }}
                    </template>

                    <template #cell(Discount)="data">
                        {{ data.value | price }}
                    </template>

                    <template #cell(Quantity)="data">
                        {{ data.value | price }}
                    </template>

                    <template #cell(Color)="data">
                        {{ data.value.Title }}
                    </template>

                    <template #cell(IsDefault)="data">
                        <b-form-checkbox
                            v-model="data.item.IsDefault"
                            name="check-button"
                            switch
                            :disabled="data.item.IsDefault"
                            @change="setDefault(data.item)"
                        >
                        </b-form-checkbox>
                    </template>

<!--                    <template #cell(Status)="data">-->
<!--                        <b-badge-->
<!--                            :variant="enums('ProductStatus', 'value', data.value, 'badge')"-->
<!--                        >-->
<!--                            {{ enums('ProductStatus', 'value', data.value, 'text') }}-->
<!--                        </b-badge>-->
<!--                    </template>-->

                    <template #cell(actions)="data">

                        <div
                                class="text-nowrap"
                        >
                            <b-link :to="{ name: 'updateproductcolor', params: { id: data.item.Id }, query:{ productid: $route.params.id }}">
                                <feather-icon
                                        :id="`invoice-row-${data.item.Id}-send-icon`"
                                        icon="EditIcon"
                                        size="16"
                                />
                            </b-link>

                            <feather-icon

                                    icon="TrashIcon"
                                    size="16"
                                    class="ml-1 cursor-pointer"
                                    @click="remove(data.item.Id)"
                            />
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                </b-table>
            </b-col>

        </b-row>
    </b-card>
</template>

<script>
export default {
    name: 'ProductColor',
    data() {
        return {
            totalRows: 1000 * 1000,
            loading: false,
            filterOptions: {
                Title: null,
                Page: 1,
                Type: 0,
            },
            fields: [
                {
                    key: 'Id',
                    label: '#',
                    thClass: 'col-width-50',
                },
                {
                    key: 'Color',
                    label: 'رنگ',
                },
                {
                    key: 'Price',
                    label: 'قیمت',
                },
                {
                    key: 'Discount',
                    label: 'تخفیف',
                },
                {
                    key: 'IsDefault',
                    label: 'پیش فرض',
                },
                {
                    key: 'Quantity',
                    label: 'تعداد',
                },
                {
                    key: 'Status',
                    label: 'وضعیت',
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: 'col-width-50',
                },
            ],
            items: [],
        }
    },
    created() {
        if (this.$store.state.zirehState.listFilter[this.$options.name]) {
            this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
        }
        this.update()
    },
    methods: {
        update(pageNumber) {
            this.loading = true

            this.filterOptions.Page = pageNumber || this.filterOptions.Page

            this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

            this.$http.post(
                this.$api.productcolor.getall, { productId: this.$route.params.id },
            )
                .then(res => {
                    this.totalRows = res.totalRow
                    this.items = res.data
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setDefault(row) {
            this.loading = true

            this.$http.post(
                this.$api.productcolor.setdefault, {id: row.Id},
            )
                .then(res => {
                    this.update()
                })
        },
        remove(id) {
            this.removeRow(this.$api.productcolor.remove, 'Id', id)
        },
    },
}
</script>

<style scoped>
.card-body{
    padding-top: 0.5rem;
}
</style>